import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { PermissionStatus } from 'src/interfaces/pushNotification'

export const usePushNotificationStore = defineStore('pushNotifications', () => {
  const deviceToken = ref<string | null>(null)
  const deviceId = ref<string | null>(null)
  const permissionStatus = ref<PermissionStatus>(PermissionStatus.PROMPT)
  const error = ref<string | null>(null)
  const isInitialized = ref(false)
  const isRegistering = ref(false)

  const hasPermission = computed(
    () => permissionStatus.value === PermissionStatus.GRANTED
  )
  const isPermissionDenied = computed(
    () => permissionStatus.value === PermissionStatus.DENIED
  )
  const isRequestingPermission = computed(
    () => permissionStatus.value === PermissionStatus.REQUESTING
  )
  const hasError = computed(() => error.value !== null)

  function setDeviceToken(token: string) {
    deviceToken.value = token
    error.value = null
  }

  function setPermissionStatus(status: PermissionStatus) {
    permissionStatus.value = status
    if (
      status === PermissionStatus.GRANTED ||
      status === PermissionStatus.DENIED
    ) {
      if (status === PermissionStatus.GRANTED) {
        error.value = null
      }
    }
  }

  function setError(errorMessage: string) {
    error.value = errorMessage
  }

  function clearError() {
    error.value = null
  }

  function setInitialized(initialized: boolean) {
    isInitialized.value = initialized
  }

  function resetState() {
    error.value = null
  }

  function setDeviceId(id: string) {
    deviceId.value = id
  }

  function setIsRegistering(registering: boolean) {
    isRegistering.value = registering
  }

  return {
    // State
    deviceToken,
    deviceId,
    permissionStatus,
    error,
    isInitialized,
    isRegistering,

    // Getters
    hasPermission,
    isPermissionDenied,
    isRequestingPermission,
    hasError,

    // Actions
    setDeviceToken,
    setDeviceId,
    setPermissionStatus,
    setError,
    clearError,
    setInitialized,
    setIsRegistering,
    resetState,
  }
})
